<template lang="pug">
 event-detail(:detail="detail" :type="type" path-name="TodayHotStock")
</template>

<script>
import EventDetail from '@components/event_detail.vue'
import Requests from '@utils/requests'
import { dateObjToDatetimeStr } from '@utils/time_helper'

export default {
  components: {
    EventDetail
  },
  data() {
    return {
      id: '',
      type: '',
      detail: {}
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.fetchList(this.$route.params.id)
      this.type = this.$route.params.type
    })
  },
  methods: {
    fetchList(id) {
      return new Promise(resolve => {
        Requests({
          url: '/shudan/get_ht_hot_recommend_detail_for_api',
          method: 'post',
          params: { sha1: id }
        }).then(({ data }) => {
          this.detail = data.data
          this.detail.timestamp = dateObjToDatetimeStr(new Date(data.data.timestamp * 1000), '.').substring(0, 16)
        })
      })
    }
  }
}
</script>
